module.exports = __webpack_public_path__ + "img/user.47be60ba.svg";